<template>
    <div class="scenario accordion my-2">
        <div v-for="(scenario, index) in scenarios" :key="index" class="accordion-item">
            <div class="accordion-header" :id="'heading-' + getID(scenario.name)">
                <button class="py-3 accordion-button collapsed bg-primary text-light border-0" type="button"
                    data-bs-toggle="collapse" :data-bs-target="'#collapse-' + getID(scenario.name)" aria-expanded="true"
                    :aria-controls="'collapse-' + getID(scenario.name)">
                    <h5 class="card-header-text m-0">{{ scenario.name }}
                    </h5>
                </button>
            </div>
            <div :id="'collapse-' + getID(scenario.name)" class="accordion-collapse collapse bg-light"
                :aria-labelledby="'heading-' + getID(scenario.name)" data-bs-parent="#accordion">
                <div class="accordion-body">
                    <img class="accordion-image" v-if="scenario.image" :src="scenario.image">
                    <p class="accordion-text mx-3 mt-2" v-html="scenario.description" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>




export default {
    name: "ScenarioAccordion",
    props: {
        scenarios: Object,
    },
    data() {
        return {
        };
    },
    methods: {
        getID(name) {
            // Replace all whitespace, slashes, and ampersands with a dash.
            let regex = /\W/g
            // Convert to lowercase and return the result.
            return name.replace(regex, '-').toLowerCase()
        }
    },

}
</script>

<style scoped>
.accordion-image {
    width: 100%;
    max-height: 400px;
    object-fit: contain;
}

.accordion-button::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
    transform: rotate(-180deg)
}

@media print {
    .card-header-text {
        color: black !important;
    }
}
</style>